// extracted by mini-css-extract-plugin
export default {"zoomModal":"V1-z","image":"W1-z","button":"X1-z","isOverlayShown":"Y1-z"};